import React from 'react';
import { Typography } from 'antd';

export const StepTitle = ({ text }: { text: string }) => {
    return <Typography.Text strong>{text}</Typography.Text>;
};
